export function getMemberRoles(member_id="",roles={}) {
    return Object.entries(roles).filter(a=>a[1].assignee===member_id).map(a=>{
        return {
            id: a[0],
            name: a[1].name
        }
    })
}